<div class="container">
  <div class="row">
    <div class="col-6" *ngFor="let navigationRoute of navigationRoutes">
      <h2 class="module-title" *ngIf="navigationRoute.isActive">{{navigationRoute.module}}</h2>
      <div *ngFor="let childrenRoute of navigationRoute.childrenRoutes" class="button-wrapper">
        <ng-container *ngIf="childrenRoute.isActive">
          <rpe-ui-button [matTooltip]="childrenRoute.tooltip ? childrenRoute.tooltip() : ''" [bg_blue]="true"
            [landing_button]="true" [disabled]="childrenRoute.disabled ? childrenRoute.disabled() : false"
            (onClick)="childrenRoute.route ? navigateTo(childrenRoute.route) : (childrenRoute.action ? childrenRoute.action() : null)">
            {{childrenRoute.name}}
          </rpe-ui-button>
        </ng-container>
      </div>
    </div>
  </div>
</div>